<template>
<div @scroll="onScroll" class="pdf-viewer">
  <div v-if="!isShow" class="text-center">
    <b-button  @click.prevent="show">
      Hiển thị
    </b-button>
  </div>
  <div v-else>
    <div v-if="loading">
      Loading...
      <span class="fa fa-spinner fa-spin"></span>
    </div>
    <div v-if="message" class="text-danger">
      {{message}}
    </div>
    <div ref="pdfContainer" v-if="loadingTask && isShow">
        <pdf
            v-for="i in lastShowPage"
            :src="loadingTask"
            class="pdf-page"
            :page="i"
            :key="i"
        ></pdf>
        <div class="text-center">
          <b-button @click.prevent="showMore" class="text-center">
            Xem thêm
          </b-button>
        </div>
    </div>
  </div>
</div>
</template>

<script>
import pdf from "vue-pdf";

export default {
  props: ["src"],
  components: {
    pdf
  },
  created() {},
  data() {
    return {
      loading: true,
      message: null,
      loadingTask: null,
      numPages: 0,
      isShow: false,
      lastShowPage: 3
    };
  },
  watch: {
    src() {
      this.isShow = false;
    }
  },
  methods: {
    loadData() {
      this.loading = true;
      this.message = null;
      this.loadingTask = pdf.createLoadingTask(this.src, {
        onProgress(e) {
          console.log(">", e);
        }
      });

      this.loadingTask
        .then(pdf => {
          this.numPages = pdf.numPages;
          this.lastShowPage = Math.min(3, this.numPages);
          this.loading = false;
        })
        .catch(e => {
          this.message = "Lỗi Download PDF";
          this.loading = false;
        });
    },
    show() {
      this.isShow = true;
      this.loadData();
    },
    showMore() {
      this.lastShowPage = Math.min(this.lastShowPage + 3, this.numPages);
    },

    onScroll(e) {
      if (
        e.target.scrollTop + e.target.clientHeight + 200 >
        this.$refs.pdfContainer.offsetHeight
      ) {
        this.showMore();
      }
    }
  }
};
</script>
<style scoped>
.pdf-viewer {
  height: 600px;
  overflow: auto;
  background: grey;
  padding: 30px;
}

.pdf-page {
  margin-bottom: 20px;
}
</style>
